import { render, staticRenderFns } from "./topIntroduce.vue?vue&type=template&id=16bfad4a&scoped=true&"
import script from "./topIntroduce.vue?vue&type=script&lang=js&"
export * from "./topIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./topIntroduce.vue?vue&type=style&index=0&id=16bfad4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bfad4a",
  null
  
)

export default component.exports